import {LocaleManager} from '@bryntum/scheduler'

import De from './custom.locale.De'

LocaleManager.registerLocale('De', {locale: De})

window.bryntum.locales = {De}
